export const scheduleButtonStyles = {
	maxWidth: '15.75rem',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
};
